import styled from 'styled-components';

export const MobilePaddingSection = styled.div`
  @media (max-width: 720px) {
    padding: 0 16px;
  }
`;

export const ProductName = styled.h1`
  font-size: clamp(14px, 3vw, 20px);
  font-weight: 500;
  line-height: 1.4;
  color: hsl(0deg 0% 0% / 87%);
  padding: 0 0 10px;

  @media (max-width: 720px) {
    padding: 0 0 10px;
  }
`;

export const ProductNameNew = styled.h1`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: hsl(0deg 0% 0% / 87%);
  padding: 0 0 10px;
  font-family: Montserrat;

  @media (max-width: 720px) {
    padding: 0 0 10px;
  }
`;

export const ProductPrice = styled.div`
  display: flex;
  align-items: baseline;
  margin: ${(props) => (props.userAlso ? '10px 0 6px' : '0')};

  & .span {
    padding-left: 9px;
  }
`;

export const TotalAmount = styled.span`
  font-weight: 600;
  color: hsl(0deg 0% 0% / 87%);
  font-size: ${(props) => (props.card ? '15px' : '20px')};
`;

export const InclTax = styled.div`
    font-size: 10px;
    color: rgb(0 0 0 / 54%);
    font-weight: 500;
    padding: font-size: ${(props) => (props.perUnit ? '0 0 2px' : '')};
`;

export const InclTaxNew = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 11px;
  font-weight: 500;
  margin-left: 12px;
`;

export const MRPname = styled.span`
  color: hsl(0deg 0% 0% / 40%);
  font-size: 14px;
  font-weight: 500;
  padding-right: 2px;
`;

export const StrikePrice = styled.span`
  color: hsl(0deg 0% 0% / 40%);
  font-size: ${(props) =>
    props.isUAE ? '12px' : props.health ? 'clamp(11px, 2vw, 14px)' : '13px'};
  text-decoration: line-through;
  font-weight: 500;
`;
export const Discount = styled.p`
  font-size: 12px;
  color: hsl(174deg 33% 54%);
  text-decoration: none;
  font-weight: 700;
`;

export const Image = styled.img`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin: ${(props) => props.margin};
  border-radius: ${(props) => props.radius};
  zoom: ${(props) => props.zoom};
  position: ${(props) => props.position};
  top: ${(props) => props.top};
`;

export const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  padding: ${(props) => props.padding};
  justify-content: ${(props) => props.justify};
  overflow-x: ${(props) => props.overflowX};
  cursor: pointer;
  overflow-y: ${(props) => props.overflowY};
  @media (max-width: 720px) {
    cursor: default;
    & ::-webkit-scrollbar {
      display: none;
    }
  }

  &.borderRight {
    border-right: 2px solid #e1e1e1;
  }

  & .reviewbodyfull {
    width: 100%;

    .reviewTitle {
      font-weight: 500;
      font-size: clamp(12px, 2vw, 16px);
      color: rgb(0 0 0 / 100%);
    }

    div {
      font-size: 12px;
      font-weight: 500;
      color: rgb(0 0 0 / 100%);
      line-height: 1.5;
      font-family: Montserrat;
    }
  }

  & .reviewbody {
    width: 70%;

    h4 {
      font-weight: 600;
      font-size: clamp(15px, 2vw, 16px);
      padding-bottom: 14px;
      color: rgb(0 0 0 / 80%);
    }

    .reviewTitle {
      font-weight: 600;
      font-size: clamp(15px, 2vw, 16px);
      padding-bottom: 14px;
      color: rgb(0 0 0 / 80%);
    }

    div {
      font-size: 14px;
      line-height: 22px;
      font-weight: 500;
      color: rgb(0 0 0 / 70%);
    }
  }

  & .reviewImage {
    height: 92px;
    width: 92px;
    float: right;
    object-fit: cover;
    border-radius: 4px;
  }

  & .react_ProductReviewItem_show_more {
    color: #63b0a8;
    font-weight: 500;
  }

  & .allreview {
    font-weight: 500;
    font-size: clamp(12px, 2vw, 14px);
    color: #ef4e5e;
    display: flex;
    align-items: center;
    padding: 8px 0 10px;

    span {
      margin: 0 4px;
    }

    img {
      width: 13px;
      height: 13px;
      margin-left: 6px;
      transform: rotate(90deg);
    }
  }
`;

export const FreeDelivery = styled.p`
  padding-left: 6px;
  color: hsl(0deg 0% 0% / 70%);
  font-size: clamp(12px, 2vw, 14px);
`;
export const Sprite = styled.span`
  margin: 0 0 0 4px;
`;

export const ProgressBarBackground = styled.div`
  border-radius: 2px;
  background: #a0927d3d;
  height: 4px;
  width: ${(props) => (props.new ? '100%' : '70%')};
  margin-bottom: 8px;
  margin-top: 10px;
`;

export const AnimatedProgress = styled.div`
  height: 4px;
  width: 0;
  border-radius: 2px;
  background: #ef4e5e;
  animation: load 2s normal forwards;

  @keyframes load {
    0% {
      width: 0;
    }
    100% {
      width: ${(props) => props.progresBarStatus};
    }
  }
`;

export const LightningDealContainer = styled.div`
  width: 100%;
  position: relative;

  &:after {
    content: 'Ends Soon!';
    position: absolute;
    right: 17%;
    bottom: -2px;
    color: hsl(0deg, 0%, 0%, 64%);
    font-size: 12px;
    @media (max-width: 1400px) {
      right: 13%;
    }
    @media (max-width: 720px) {
      right: 7%;
    }
  }
`;

export const RibbonContainer = styled.div`
  display: flex;
  align-items: center;
  width: 68%;
  justify-content: space-between;
  column-gap: 10px;
  margin: 14px 0;
  @media (min-width: 1600px) {
    width: 60%;
  }
`;

export const LighteningDealRibbon = styled.div`
  background-color: hsl(0deg, 0%, 0%, 0.08);
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  padding: 6px 22px 6px 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  position: relative;
  height: 30px;
  @media (max-width: 1430px) {
    font-size: 11px;
    height: 40px;
  }
  @media (max-width: 720px) {
    padding: 8px 22px 8px 10px;
    font-size: 10px;
    height: 50px;
  }

  img {
    width: 9px;
    height: 11px;
    margin-right: 4px;
  }

  &:after {
    content: '';
    position: absolute;
    height: 0;
    width: 0;
    border-width: 15px 8px;
    border-style: solid;
    border-color: #ebebeb white #ebebeb #ebebeb;
    top: 0px;
    right: 0px;
    @media (max-width: 1430px) {
      border-width: 20px 8px;
    }
    @media (max-width: 720px) {
      border-width: 25px 10px;
    }
  }
`;

export const PriceDropped = styled.div`
  font-size: clamp(13px, 2vw, 14px);
  color: #ef4e5e;
  font-weight: 500;
`;

export const LightningSectionNew = styled.div`
  position: relative;
  margin-top: 10px;

  img {
    width: 100%;
  }

  @media (min-width: 768px) {
    width: 60%;
  }
`;

export const DealDetails = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: #000;
`;

export const DealSection = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

export const DealName = styled.p`
  font-size: 12px;
  font-weight: normal;
  color: #6e6e6e;
`;

export const DealContainer = styled.div`
  position: absolute;
  top: 0;
  padding: 8px 12px;
  width: 100%;
`;
